import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';

export const authorizedOnlyGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routeService = inject(RouteService);

    return inject(UserStoreService).getUser().pipe(
        take(1),
        switchMap(user => {
            if (user?.loginData != null) {
                return of(true);
            }

            return onUnauthorizedUser(state, routeService);
        })
    );
};

const onUnauthorizedUser = (state: RouterStateSnapshot, routeService: RouteService): Observable<boolean> => {
    routeService.navigate(RpcRoute.Login, routeService.formReturnUrlNavigationExtras(state)).catch(() => { });

    return of(false);
};